import { ResourcesConfig } from "aws-amplify";

const config: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: 'us-east-1_dSJG8dFT7',
            userPoolClientId: '3rdvsc5iilmdl578m1f6bj6em0',
            identityPoolId: '',
            allowGuestAccess: true,
            signUpVerificationMethod: 'code',
            loginWith: {
                oauth: {
                    domain: '',
                    scopes: [
                        'email',
                        'openid',
                        'phone'
                    ],
                    redirectSignIn: [''],
                    redirectSignOut: [''],
                    responseType: 'code'
                }
            }
        }
    }
}

export default config;